import { FiCheck } from 'react-icons/fi';
import {
  MdArrowRight,
  MdRemove,
  MdSubdirectoryArrowRight,
} from 'react-icons/md';
import styled from 'styled-components';

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const TableContainer = styled.div`
  padding: 32px;
`;

const MainPageContainer = styled.div`
  padding: 32px;
`;

const PillContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MultiSelectIcon = styled(FiCheck)`
  height: 24px;
  width: 24px;
  margin-left: 20px;
`;

const SubCategoryContainer = styled.div`
  display: grid;
  height: 64px;
  border-bottom: 0.5px solid #eaedf3;
`;
const SubCategory = styled.div`
  display: flex;
  align-items: center;
`;
const SubCategoryName = styled.span``;
const SubCategoryActions = styled.div``;

const OpenGroupIcon = styled(MdArrowRight)`
  rotate: 90deg;
  font-size: 24px;
  cursor: pointer;
`;

const ClosedGroupIcon = styled(MdArrowRight)`
  cursor: pointer;
  font-size: 24px;
`;

const SubCategoryIcon = styled(MdRemove)``;

const EnterIcon = styled(MdSubdirectoryArrowRight)``;

const IconContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
  border-radius: 2px;
  svg {
    margin: 0 0px 0 -10px;
  }
`;

const IconImage = styled.img`
  height: auto;
  width: 100%;
`;

const categoriesStyle = {
  Heading,
  MainPageContainer,
  TableContainer,
  PillContainer,
  SubCategoryContainer,
  SubCategory,
  SubCategoryName,
  SubCategoryActions,
  OpenGroupIcon,
  ClosedGroupIcon,
  SubCategoryIcon,
  EnterIcon,
  MultiSelectIcon,
  IconContainer,
  IconImage,
};

export default categoriesStyle;
